//@ts-nocheck
import { useEffect, useRef, useState } from "react";
import { quizGrader, unansweredQs } from "./quiz-grader";
import { scrollToId } from "../../utils/functions";

/////////////////////////////////////////////////////////

function useInterval(callback, delay) {
  const savedCallback = useRef<any>();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

/////////////////////////////////////////////////////////

export function useQuestionTracker({
  quiz,
  processAnswers,
  defaultIndex = 1,
  _canTakeQuiz = true,
}) {
  let { questions, duration: quizDuration } = quiz;
  let _duration = quizDuration > 0 && quizDuration * 60 * 1000;

  let [currentQ, setCurrentQ] = useState(defaultIndex);
  let [completed, setCompleted] = useState(!_canTakeQuiz);
  let [answers, setAnswers] = useState({});
  let elapsedTime = useRef(Date.now());
  let [duration, setDuration] = useState(_duration);
  let { unansweredQuestions } = unansweredQs(answers, questions);

  useInterval(() => {
    if (duration === 0) {
      setCompleted(true);
    }
    if (!completed) {
      setDuration((x) => x - 1000);
    }
  }, 1000);

  function nextQuestion() {
    if (currentQ < questions.length) {
      setCurrentQ(currentQ + 1);
      scrollToId("Navigation");
    } else {
      setCompleted(true);
    }
  }
  function previousQuestion() {
    if (currentQ > 1) {
      setCurrentQ(currentQ - 1);
      scrollToId("Navigation");
    }
  }
  function selectAnswer(option) {
    setAnswers({ ...answers, [currentQ]: option });
  }
  const handleSubmission = () => {
    if (!completed) setCompleted(true);
    let timeElapsed = (Date.now() - elapsedTime.current) / 1000;
    let quizResult = quizGrader(answers, questions);
    processAnswers(quizResult, timeElapsed);
  };

  useEffect(() => {
    if (completed) {
      handleSubmission();
    }
  }, [completed]);

  return {
    nextQuestion,
    previousQuestion,
    selectAnswer,
    completed,
    setCurrentQ,
    lastQuestion: questions.length,
    unansweredQs: unansweredQuestions,
    handleSubmission,
    duration,
    questionNo: currentQ,
    currentAnswer: answers[currentQ],
    question: questions[currentQ - 1],
  };
}

export function useTimerHook({ quiz, _canTakeQuiz = true }) {
  let { questions, duration: quizDuration } = quiz;
  let _duration = quizDuration > 0 && quizDuration * 60 * 1000;

  // let [completed, setCompleted] = useState(!_canTakeQuiz);
  let [timeElapsed, setTimeElapsed] = useState(false);
  let [duration, setDuration] = useState(_duration);

  useInterval(() => {
    if (duration === 0) {
      setTimeElapsed(true);
    }
    if (!timeElapsed) {
      setDuration((x) => x - 1000);
    }
  }, 1000);

  return {
    duration,
    timeElapsed,
  };
}
